/* eslint camelcase: 0 */
import {
  ActivateRequest,
  Auth,
  ChangeEmailRequest,
  ChangePasswordRequest,
  EmailRequest,
  ForgetRequest,
  LoginRequest,
  PasswordRequest,
  SignupRequest
} from '@/infrastructure/network/Monitaro/schema/models'
import { IAuthProps, EmptyAuthPropsFactory } from '@/entities/Auth'
import { IAccountProps } from '@/entities/Account'

export const toAuthProps = (props: Auth | null | undefined): IAuthProps => {
  if (!props) {
    return EmptyAuthPropsFactory()
  }

  const { access_token, token_type, expired } = props

  return EmptyAuthPropsFactory({
    accessToken: access_token,
    tokenType: token_type,
    expired
  })
}

export const toSignupRequest = (props: IAccountProps): SignupRequest => {
  const { username, password } = props
  return {
    username: username!,
    password: password!
  }
}

export const toLoginRequest = (props: IAccountProps): LoginRequest => {
  const { username, password } = props
  return {
    username: username!,
    password: password!
  }
}

export const toForgetRequest = (props: IAccountProps): ForgetRequest => {
  const { username } = props
  return {
    username: username!
  }
}

export const toChangeEmailRequest = (props: IAccountProps): ChangeEmailRequest => {
  const { code, password } = props
  return {
    code: code!,
    password: password!
  }
}

export const toChangePasswordRequest = (props: IAccountProps): ChangePasswordRequest => {
  const { code, password } = props
  return {
    code: code!,
    password: password!
  }
}

export const toActivateRequest = (props: IAccountProps): ActivateRequest => {
  const { code } = props
  return {
    code: code!
  }
}

export const toEmailRequest = (props: IAccountProps): EmailRequest => {
  const { username } = props
  return {
    username: username!
  }
}

export const toPasswordRequest = (props: IAccountProps): PasswordRequest => {
  const { password, newPassword } = props
  return {
    password: password!,
    new_password: newPassword!
  }
}
